import { memo, useCallback } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CampaignSelect from '../../../components/CampaignSelect';
import { useContactsCampaignFormContext } from '../context/ContactsCampaignFormContext';
import { jsx as _jsx } from "react/jsx-runtime";
function ContactsCampaignSelect({
  editCampaignObjectId
}) {
  const {
    selectedCampaign,
    setSelectedCampaign,
    disabledCampaignNames
  } = useContactsCampaignFormContext();
  const isEditMode = Boolean(editCampaignObjectId);
  const handleCampaignSelectChange = useCallback(({
    target: {
      value
    }
  }) => {
    setSelectedCampaign(value);
  }, [setSelectedCampaign]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaignSelect.marketingCampaign"
    }),
    marginBlockEnd: "500",
    children: /*#__PURE__*/_jsx(CampaignSelect, {
      value: selectedCampaign,
      onChange: handleCampaignSelectChange,
      disabledOptionsByName: disabledCampaignNames,
      canCreateCampaigns: !isEditMode,
      uiSelectProps: {
        disabled: isEditMode
      },
      enableTracking: true
    })
  });
}
export default /*#__PURE__*/memo(ContactsCampaignSelect);